import { connect } from 'react-redux';
import IdVerification from 'account/components/id_verification';
import { fetchIdPhotoIfNeeded } from 'registration/creative/ducks';

const mapStateToProps = ({ creativeRegistration }) => {
  const {
    idVerificationStatus, registrationSubmittedAt, registrationReopenedAt, idValidated, fetching
  } = creativeRegistration;

  return {
    status: idVerificationStatus,
    submittedAt: registrationSubmittedAt,
    reopenedAt: registrationReopenedAt,
    idValidated,
    fetching
  };
}

export default connect(mapStateToProps, {
  fetchIdPhotoIfNeeded
})(IdVerification);



// WEBPACK FOOTER //
// ./account/containers/id_verification/index.js